import React, { useState, useEffect } from "react";

function TextInput({ label = "Full name", onTextChanged, placeholder = "Enter name", width = "296px", value = "" }) {
  const [text, setText] = useState(value || "");

  useEffect(() => {
    setText(value || "");
  }, [value]);

  const textChanged = (e) => {
    const next = e.target.value;
    setText(next);
    if (onTextChanged) {
      onTextChanged(next);
    }
  };

  return (
    <div className={`w-[${width}] h-[64px]`}>
      <p className=" text-[12px] font-OpenSansMedium font-[600] text-inputEmailTitle">{label}</p>
      <div className="w-full h-[30px] border-solid border-[1px] rounded-[5px] flex items-center justify-center px-[15px]">
        <input
          value={text}
          type="text"
          onChange={textChanged}
          className="w-full text-inputEmailTitle text-[11px] font-[400] font-OpenSansMedium"
          placeholder={placeholder}
        />
      </div>
    </div>
  );
}

export default TextInput;
